import {
  Datagrid,
  EditButton,
  List,
  TextField,
  FunctionField,
} from "react-admin";

export const OrganizationList: React.FC = (props: any) => {
  return (
    <List {...props}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="name" label="组织名称" />
        <TextField source="alias" label="别名" />
        <FunctionField
          label="启用"
          render={(record: any) => (record.enabled ? "是" : "否")}
        />
        <FunctionField
          label="域名"
          render={(record: any) =>
            record.domains && record.domains.length > 0
              ? record.domains
                  .map(
                    (domain: any) =>
                      `${domain.name} (验证: ${domain.verified ? "是" : "否"})`
                  )
                  .join(", ")
              : "无"
          }
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};
